import React, {useEffect, useState} from "react";
import {Button, Card, CardBody, CardImg, Modal, ModalBody, ModalHeader, ModalTitle} from "react-bootstrap";
import {url} from "../utils/UrlsUtil.ts";
import EventMsgTemplateSwiper from "../components/swiper/EventMsgTemplateSwiper.tsx";
import {fetchPost} from "../utils/FetchUtil.ts";
import "../../style/modal/event_msg_template_modal.scss";

interface EventMsgTemplateModalProps{
    templateKbn:string;
    show: boolean;
    onClosed: () => void;
    onSelected: ( msg:string ) => void;
}
const EventMsgTemplateModal:React.FC<EventMsgTemplateModalProps> = (
    {
        templateKbn = "20",
        show = false,
        onClosed = () => {},
        onSelected = () => {},
    }
) => {
    const [selectedCategoryCode, setSelectedCategoryCode] = useState<string>("");
    const [msgTemplateList, setMsgTemplateList] = useState<SampleMessageDto[]>([]);
    useEffect(() => {
        const getCategoryTemplateList = async () =>{
            try{
                const data = await fetchPost({
                    action: "/api/template/event/category/msg_templates",
                    data: {template_kbn: templateKbn, event_category_code: selectedCategoryCode},
                });
                if(data != null){
                    //イベントカテゴリーメッセージテンプレートを取得
                    setMsgTemplateList(data["msg_sample_list"]);
                }
            }catch (e) {
                console.log(e);
            }
        }
        getCategoryTemplateList().finally(()=>{});
    }, [selectedCategoryCode]);
    const onSelectedCategory = (code: string) => {
        setSelectedCategoryCode(code);
    }
    return (
        <Modal className="event-msg-template-modal" show={show} onHide={onClosed} centered>
            <ModalHeader closeButton>
                <ModalTitle><img src={url("/images/logo/geeva_logo.png")} alt="geeva"/></ModalTitle>
            </ModalHeader>
            <ModalBody>
                <h2>メッセージをイベントからお選びください</h2>
                <EventMsgTemplateSwiper templateKbn={templateKbn} showTemplate={false} onSelectedCategory={onSelectedCategory}></EventMsgTemplateSwiper>
                {msgTemplateList && msgTemplateList.length > 0 && msgTemplateList.map((msg: SampleMessageDto, index: number) =>
                    <dl className={`msg-tmp-item`} key={`dl_msg_tmp_${index}`}
                        onClick={()=>{onSelected(msg.sample_message)}}
                    >
                        <dt>{msg.title}</dt>
                        <dd dangerouslySetInnerHTML={{ __html: msg.sample_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}></dd>
                    </dl>)}
            </ModalBody>
        </Modal>
    );
}
export default EventMsgTemplateModal